
export const backendserverurl ='https://echnewsaas-9242363bk-01.pitech.co.ug'

// Add any other JavaScript code here
//http://127.0.0.1:8000/

//http://165.227.183.69:10225

//https://echnewsaas-9242363bk-01.pitech.co.ug  --pisacco demo
//https://ends4efinancialservices-6394327bk-01.pitech.co.ug --frnds
//pctsacco-7099212bk-01.pitech.co.ug --kca
//https://sasacco-5111608bk-01.pitech.co.ug/ --UMI

//sacco-2278373bk-01.pitech.co.ug	--ksgu
//
//

//entaletradersfinancialservices-2017596bk-01.pitech.co.ug